var attrsToMap = function attrsToMap(nodeAttributes) {
  var attributeObject = {};
  var attributeLength = nodeAttributes.length;

  for (var i = 0; i < attributeLength; i++) {
    var element = nodeAttributes[i];
    attributeObject[element.nodeName] = element.nodeValue;
  }

  return attributeObject;
};
/**
 * Создаем компонент из которого забираем все аттрибуты
 * которые прописаны в коментариях
 */


export var getAttrs = function getAttrs(mrCounterComment) {
  var el = document.createElement('div');
  mrCounterComment = mrCounterComment.trim().replace('mr_counter', '');
  el.innerHTML = "<mr_counter ".concat(mrCounterComment, " />");
  return attrsToMap(el.firstElementChild.attributes);
};